import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SystemItemPriceChange {
  estimate_line_item_id: string;
  system_line_item_id: string;
  price_at_add: number;
  current_price: number;
  price_changed: boolean;
}

export function useSystemItemPriceChanges(
  estimateId: string | null,
  isDraft: boolean
) {
  return useQuery({
    queryKey: ['system_item_price_changes', estimateId, isDraft],
    queryFn: async (): Promise<SystemItemPriceChange[]> => {
      if (!estimateId) return [];
      const { data, error } = await (supabase.rpc as any)(
        'check_system_item_price_changes',
        { p_estimate_id: estimateId }
      );
      if (error) throw error;
      return (data as SystemItemPriceChange[]) ?? [];
    },
    enabled: !!estimateId && isDraft,
    staleTime: 60 * 1000,
  });
}
